import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
//import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core';
import { MasterInit } from '../_metronic/layout/MasterInit';
import { AuthInit } from './modules/auth';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { get_google_client_id } from './helpers/environment';
import { SignalProvider } from './helpers/SignalContext';
import { useDisableNumberInputScroll } from './hooks/useDisableNumberInputScroll';
import { AnnouncementBanner } from './components/AnnouncementBanner';

const App = () => {
  useDisableNumberInputScroll();
  return (
    <SignalProvider>
      <Suspense fallback={<LayoutSplashScreen />}>
        {/* <I18nProvider> */}
        <LayoutProvider>
          <AuthInit>
            <GoogleOAuthProvider clientId={get_google_client_id()}>
              <Outlet />
              <AnnouncementBanner />
            </GoogleOAuthProvider>
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
        {/* </I18nProvider> */}
      </Suspense>
    </SignalProvider>
  );
};

export { App };
